var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import leaveCase from "~/components/outsource-manage/collection-manage/leave-case.vue"; // 留案
import { State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceCollectionService } from "~/services/domain-service/outsource-collection-manage.service";
import FileUpload from "~/components/common/file-upload.vue";
import { CityService } from "~/utils/city.service";
import { OutsourceSettleManageService } from "~/services/domain-service/outsource-settle-manage.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TeamCaseBatchRepayment from "~/components/visit-case/team-case-batch-repayment.vue";
import TeamCaseRepayment from "~/components/visit-case/team-case-repayment.vue";
var CollectionManageIndex = /** @class */ (function (_super) {
    __extends(CollectionManageIndex, _super);
    function CollectionManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            leaveCase: false,
            uploadFile: false,
            batchRepayment: false,
            repayment: false
        };
        _this.fileList = [];
        _this.showSMData = "";
        _this.selectCaseList = [];
        _this.teamCaseObj = {};
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        _this.queryModel = {
            outBatch: "",
            caseNumber: "",
            personalName: "",
            area: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            outsourceId: "",
            overduePeriod: "",
            turnSource: "",
            productCategory: "",
            productName: "",
            proinviceCode: "",
            cityCode: "",
            followupBack: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overdueDays: {
                max: "",
                min: ""
            },
            collectorRealName: "",
            customerCategory: "",
            leaveCaseFlag: "",
            followInTime: [],
            outEndDate: [],
            outTimeDate: [],
            followUpTime: [],
            labelName: []
        };
        _this.collectionDataList = []; //数据列表
        _this.selectionList = []; //选中数据
        _this.caseIds = []; //选择的案件号数组
        _this.importFlag = ""; //选择导入标识
        return _this;
    }
    CollectionManageIndex.prototype.mounted = function () {
        this.refreshData();
        this.getProvinces();
    };
    //获取省数据
    CollectionManageIndex.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    CollectionManageIndex.prototype.getCitys = function (provinceId) {
        if (this.queryModel.cityCode) {
            this.queryModel.cityCode = "";
        }
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    CollectionManageIndex.prototype.refreshData = function () {
        var _this = this;
        // 默认加载列表
        this.outsourceCollectionService
            .earchCaseOutList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.collectionDataList = data;
            _this.selectionList = [];
        });
    };
    // 关闭弹框
    CollectionManageIndex.prototype.close = function () {
        var upload = this.$refs["upload_case_import"];
        upload.reset();
        this.dialog.uploadFile = false;
    };
    /**
     * 批量还款
     */
    CollectionManageIndex.prototype.batchRepaymentClick = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.batchRepayment = true;
            this.selectCaseList = this.selectionList;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u6279\u91CF\u8FD8\u6B3E\u7684\u6848\u4EF6");
        }
    };
    /**
     * 批量还款弹窗关闭回调
     */
    CollectionManageIndex.prototype.dialogClose = function () {
        this.refreshData();
        this.dialog.batchRepayment = false;
        this.selectionList = [];
    };
    /**
     * 还款
     */
    CollectionManageIndex.prototype.repaymentClick = function (row) {
        this.dialog.repayment = true;
        this.teamCaseObj = row;
    };
    // 导入电催跟进
    CollectionManageIndex.prototype.commit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message("请上传导入文件");
            return;
        }
        var query = {
            fileId: this.fileList[0].response.id
        };
        if (this.importFlag === "importMobileUrge") {
            // 导入电催跟进
            this.outsourceCollectionService
                .importMobileUrge(query)
                .subscribe(function (data) {
                //          this.dialog.uploadFile = false;
                _this.close();
                _this.refreshData();
                if (data.length !== 0) {
                    _this.$message.info("存在导入失败的案件号");
                }
                else {
                    _this.$message.success("导入成功");
                }
            });
        }
        else if (this.importFlag === "importOutVisit") {
            // 导入外访跟进
            this.outsourceCollectionService.importOutVisit(query).subscribe(function (data) {
                //          this.dialog.uploadFile = false;
                _this.close();
                _this.refreshData();
                if (data.length !== 0) {
                    _this.$message.info("存在导入失败的案件号");
                }
                else {
                    _this.$message.success("导入成功");
                }
            });
        }
        else if (this.importFlag === "importOutVisitEnclosure") {
            // 导入外访附件
            this.outsourceCollectionService
                .importOutVisitEnclosure(query)
                .subscribe(function (data) {
                _this.dialog.uploadFile = false;
                _this.refreshData();
            });
        }
    };
    //回收案件
    CollectionManageIndex.prototype.caseRecoveryClick = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要回收的案件");
            return;
        }
        var caseIds = this.selectionList.map(function (v) { return v.id; });
        var query = {
            caseIds: caseIds
        };
        this.outsourceCollectionService.caseRecovery(query).subscribe(function (data) {
            _this.$message.success("回收案件成功!");
            _this.refreshData();
        });
    };
    //留案
    CollectionManageIndex.prototype.caseStayClick = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择需要留案的案件");
            return;
        }
        this.dialog.leaveCase = true;
    };
    //取消留案
    CollectionManageIndex.prototype.unCaseStayClick = function () {
        var _this = this;
        if (this.selectionList.length === 0) {
            this.$message.info("请选择需要取消留案的案件");
            return;
        }
        var caseIds = this.selectionList.map(function (v) { return v.id; });
        var query = {
            caseIds: caseIds
        };
        this.outsourceCollectionService.unCaseStay(query).subscribe(function (data) {
            _this.$message.success("取消留案成功!");
            _this.refreshData();
        });
    };
    //导入电催跟进
    CollectionManageIndex.prototype.importMobileUrgeClick = function () {
        this.showSMData = 3;
        this.dialog.uploadFile = true;
        this.importFlag = "importMobileUrge";
    };
    //导入外访跟进
    CollectionManageIndex.prototype.importOutVisitClick = function () {
        this.showSMData = 4;
        this.dialog.uploadFile = true;
        this.importFlag = "importOutVisit";
    };
    //导入外访附件
    CollectionManageIndex.prototype.importOutVisitEnclosureClick = function () {
        this.dialog.uploadFile = true;
        this.importFlag = "importOutVisitEnclosure";
    };
    /**
     * 进入查看执行页
     */
    CollectionManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 重置numberRange
     */
    CollectionManageIndex.prototype.follFeedback = function () {
        this.queryModel.overdueAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.proinviceCode = "";
        this.queryModel.cityCode = "";
        this.queryModel.outsourceId = "";
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(OutsourceSettleManageService)
    ], CollectionManageIndex.prototype, "OutsourceSettleManageService", void 0);
    __decorate([
        Dependencies(OutsourceCollectionService)
    ], CollectionManageIndex.prototype, "outsourceCollectionService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CollectionManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CollectionManageIndex.prototype, "sortService", void 0);
    __decorate([
        State
    ], CollectionManageIndex.prototype, "outSourceList", void 0);
    CollectionManageIndex = __decorate([
        Auth(1003),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                leaveCase: leaveCase,
                FileUpload: FileUpload,
                TeamCaseBatchRepayment: TeamCaseBatchRepayment,
                TeamCaseRepayment: TeamCaseRepayment
            }
        })
    ], CollectionManageIndex);
    return CollectionManageIndex;
}(Vue));
export default CollectionManageIndex;
